import { OrderDetail } from '@insurance/api/requests'
import { createContext, useContext } from 'react'

type CmrInsuranceValues = {
  isEditable: boolean
  order?: OrderDetail
  isApprove?: boolean
}

const CmrInsuranceContext = createContext<CmrInsuranceValues>({
  isEditable: false,
  isApprove: false
})

export const CmrInsuranceProvider = ({
  children,
  ...values
}: React.PropsWithChildren<CmrInsuranceValues>) => {
  return (
    <CmrInsuranceContext.Provider value={values}>
      {children}
    </CmrInsuranceContext.Provider>
  )
}

export const useCmrInsuranceValues = () => useContext(CmrInsuranceContext)
